import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { InteractivePricingCalculatorComponent } from './interactive-pricing-calculator.component';
import { IisPricingComponent } from './iis-pricing.component';

@NgModule({
  declarations: [
    InteractivePricingCalculatorComponent,
    IisPricingComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule
  ],
  exports: [
    InteractivePricingCalculatorComponent,
    IisPricingComponent
  ]
})
export class PricingModule { }